'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCombinedProperties = addCombinedProperties;

var _amsLoaderUtils = require('@artsman/ams-loader-utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * Decorator to initialize all the individual entries in the schema as properties that return the combined
 * value of the current instance.  This is really just a shorthand for `this.someAttribute` instead of
 * `this._combined.someAttribute`.
 */
function addCombinedProperties(target) {
  // Extend the target (rather than mutating it)
  var CombinedProperties = function (_target) {
    _inherits(CombinedProperties, _target);

    function CombinedProperties() {
      _classCallCheck(this, CombinedProperties);

      return _possibleConstructorReturn(this, (CombinedProperties.__proto__ || Object.getPrototypeOf(CombinedProperties)).apply(this, arguments));
    }

    return CombinedProperties;
  }(target);

  var schemaKeys = CombinedProperties.schema.keys;

  /*
   * This was intended to be a development mode only check, but introduces a dependency on node/webpack and makes unit
   * testing harder, so we'll just run it in all modes for now. If necessary, it can be optimized later in production mode.
   */
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = schemaKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var attribute = _step.value;

      if (target.prototype.hasOwnProperty(attribute)) {
        throw new TypeError('Conflict on schema for attribute "' + attribute + '" on "' + target.name + '" when adding combined properties');
      }
    }

    // Add all new combined properties
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    var _loop = function _loop() {
      var attribute = _step2.value;

      Object.defineProperty(CombinedProperties.prototype, attribute, {
        get: function get() {
          // "this" in this context will be the instance of the class after it's bound by the constructor.
          return this.getIn(['_combined', attribute]);
        },
        configurable: false,
        enumerable: true
      });
    };

    for (var _iterator2 = schemaKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      _loop();
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  CombinedProperties.displayName = 'CombinedProperties(' + (0, _amsLoaderUtils.getDisplayName)(target) + ')';
  CombinedProperties.WrappedSchema = target;

  return CombinedProperties;
}